(() => {
  const icons = {
    top: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8"/><circle cx="12" cy="12" r="2.6"/></svg>`,
    heart: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12c-4.6-1.3-6.5-4.2-4.7-6.4 1.6-1.9 4-.8 4.7 1.2.7-2 3.1-3.1 4.7-1.2 1.8 2.2-.1 5.1-4.7 6.4Z"/><path d="M12 12c-1.2 4.5-4 6.5-6.2 4.7-1.9-1.5-.9-4 1.2-4.7-2.1-.7-3.1-3.2-1.2-4.7"/><path d="M12 12c1.2 4.5 4 6.5 6.2 4.7 1.9-1.5.9-4-1.2-4.7 2.1-.7 3.1-3.2 1.2-4.7"/></svg>`,
    base: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v8M8 7l4 4 4-4"/><path d="M12 11c0 4-2.5 4.7-5 6M12 11c0 4 2.5 4.7 5 6M12 14v7M7 17l-2 3M17 17l2 3"/></svg>`,
    guide: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="6" r="1.5"/><circle cx="6" cy="12" r="1.5"/><circle cx="6" cy="18" r="1.5"/><path d="M10 6h8M10 12h8M10 18h8"/></svg>`,
    finder: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="5.5"/><path d="m14.5 14.5 5 5M18 4v3M16.5 5.5h3"/></svg>`,
    mark: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 18c4-6 6-9 10-12 1.8-1.3 3.7.8 2.3 2.5-2.8 3.4-5.7 5.5-10.3 8.5"/><path d="M5 18c3.8-.7 7-.3 10 1"/><path d="M17.5 5.5 19 4"/></svg>`,
    details: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 10.5v6M12 7.5h.01"/></svg>`
  };

  const labels = [
    { match: "kopfnote", type: "top", label: "Kopfnote" },
    { match: "herznote", type: "heart", label: "Herznote" },
    { match: "basisnote", type: "base", label: "Basisnote" },
    { match: "so funktioniert es", type: "guide", label: "So funktioniert es" },
    { match: "duftfinder integration", type: "finder", label: "Duftfinder Integration" },
    { match: "the mark", type: "mark", label: "The Mark" },
    { match: "details", type: "details", label: "Details" }
  ];

  function enhance(root = document) {
    root.querySelectorAll(".shopify-section--main-product .product-info__description details").forEach((details) => {
      if (details.dataset.shinwarEnhanced === "true") return;

      const summary = details.querySelector(":scope > summary");
      if (!summary) return;

      const raw = summary.textContent.replace(/^◇\s*/, "").trim().toLowerCase();
      const config = labels.find((item) => raw.startsWith(item.match));
      if (!config) return;

      details.dataset.shinwarEnhanced = "true";
      details.dataset.note = config.type;
      details.classList.add("shinwar-fragrance-accordion");

      summary.textContent = "";

      const icon = document.createElement("span");
      icon.className = "shinwar-note-icon";
      icon.innerHTML = icons[config.type];

      const label = document.createElement("span");
      label.className = "shinwar-note-label";
      label.textContent = config.label;

      const chevron = document.createElement("span");
      chevron.className = "shinwar-note-chevron";
      chevron.setAttribute("aria-hidden", "true");

      summary.append(icon, label, chevron);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => enhance());
  } else {
    enhance();
  }

  document.addEventListener("shopify:section:load", (event) => enhance(event.target));
})();